import { Base, importOnInteraction, importWhenVisible } from '@studiometa/js-toolkit';
import { Panel, Accordion } from '@studiometa/ui';
import LargeText from '../atoms/LargeText.js';
import CardWithCursor from '../molecules/CardWithCursor.js';
import ParallaxImage from '../atoms/ParallaxImage/ParallaxImage.js';
import PushSlider from '../molecules/PushSlider/PushSlider.js';
import QuickAccess from '../molecules/QuickAccess.js';
import Toggle from '../molecules/Toggle.js';
import Slider from '../molecules/Slider.js';
import Listing from '../molecules/Listing/index.js';
import EventsList from '../molecules/EventsList/EventsList.js';

/**
 * PageBuilder component
 */
export default class PageBuilder extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'PageBuilder',
    components: {
      LargeText,
      CardWithCursor,
      Collapse: (app) =>
        importWhenVisible(() => import('../molecules/Collapse/index.js'), 'Collapse', app),
      PageFAQ: (app) => importWhenVisible(() => import('./PageFAQ.js'), 'PageFAQ', app),
      ParallaxImage,
      Panel,
      Map: (app) => importWhenVisible(() => import('../molecules/Location/index.js'), 'Map', app),
      PushSlider,
      QuickAccess,
      Toggle,
      SliderWithBreakpoint: (app) =>
        importWhenVisible(
          () => import('../molecules/SliderWithBreakpoint.js'),
          'SliderWithBreakpoint',
          app,
        ),
      VideoPlayer: (app) =>
        importOnInteraction(
          () => import('../molecules/VideoPlayer.js'),
          'VideoPlayer',
          'mouseenter',
          app,
        ),
      Slider,
      Listing,
      Accordion,
      EventsList,
      Sticky: (app) => importWhenVisible(() => import('../molecules/Sticky.js'), 'Sticky', app),
    },
  };
}
